/* eslint-disable max-len,no-console,no-unused-vars,no-unreachable */

import store from '../store';
import accessGroup from '../router/accessGroup';

function isAdmin () {
    return store.getters.user_is_admin;
}

function userGranted (routeName) {
    if (isAdmin()) {
        return true;
    }
    const routeAccess = accessGroup.route_access[routeName];
    const userPermitted = store.getters.user_has_role(routeAccess);
    // if routeAccess is null or undefined access is allowed
    return !!(!routeAccess || (routeAccess && userPermitted));
}

/**
 * Check if user is allowed to
 * access current route
 * @param to
 * @param from
 * @param next
 */
const isUserGranted = (to, from, next) => {
    if (userGranted(to.name)) {
        next();
    } else {
        next('/');
    }
};

/**
 * Redirect if not authenticated
 * @param to
 * @param from
 * @param next
 */
const redirectIfNotAuthenticated = (to, from, next) => {
    if (to.path === '/login') next();

    if (!store.getters.is_authenticated) {
        next('/login');
    } else {
        next();
    }
};

/**
 * Disable login route if user
 * is already authenticated
 * @param to
 * @param from
 * @param next
 */
const disabledIfIsAuthenticated = (to, from, next) => {
    if (store.getters.is_authenticated) {
        next(from.path);
    } else {
        next();
    }
};

const startPage = (to, from, next) => {
    if (userGranted(to.name)) {
        next('/orders');
    } else {
        next('/buildings');
    }
};

export default { isUserGranted, redirectIfNotAuthenticated, disabledIfIsAuthenticated, startPage };



// WEBPACK FOOTER //
// ./src/util/middleware.js